const getters = {};

/**
 * point 정보
 * @param {*} state
 * @returns {Object}
 */
getters.pointInfo = (state) => {
  return state.point.pointInfo;
};

/**
 * point 내역
 * @param {*} state
 * @returns {Object}
 */
getters.pointList = (state) => {
  return state.point.pointList;
};

/**
 * point 내역 페이지 사이즈
 * @param {*} state
 * @returns {Number}
 */
getters.pointListPageSize = (state) => {
  return state.point.pointListPageSize;
};

/**
 * point 내역 현재 페이지
 * @param {*} state
 * @returns {Number}
 */
getters.pointListPageNo = (state) => {
  return state.point.pointListPageNo;
};

/**
 * point 내역 시작일
 * @param {*} state
 * @returns {String}
 */
getters.pointListStartDate = (state) => {
  return state.point.pointListStartDate;
};

/**
 * point 내역 종료일
 * @param {*} state
 * @returns {String}
 */
getters.pointListEndDate = (state) => {
  return state.point.pointListEndDate;
};

/**
 * point 내역 상태
 * @param {*} state
 * @returns {Number}
 */
getters.pointListStatus = (state) => {
  return state.point.pointListStatus;
};

export default {
  ...getters,
};
